import { render, staticRenderFns } from "./Frame.layout.vue?vue&type=template&id=7d41c7a8&lang=pug&"
import script from "./Frame.layout.vue?vue&type=script&lang=ts&"
export * from "./Frame.layout.vue?vue&type=script&lang=ts&"
import style0 from "./Frame.layout.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports